<template>
  <div class="" v-if="isPropertyLoading">
    <Loading />
  </div>

  <div v-else>
    <BethsLayout :layoutTitle="`Unsubscribe - ${property?.name}`">
      <div class="flex flex-col justify-center min-h-600">
        <div
          class="m-auto my-10 border-2 border-gray-300 shadow-md rounded-md w-12/12 lg:w-6/12 md:w-8/12 sm:10/12"
        >
          <div class="px-8 py-8 rounded-xl">
            <h1
              id="unsubscribe-training-title"
              name="unsubscribe-training-title"
              class="mt-2 font-normal text-2xl"
            >
              <div class="font-normal">
                Unsubscribe from training expiration emails
              </div>
              <div class="font-bold">{{ property?.name }}</div>
            </h1>

            <Loading v-if="isWorking" />

            <div v-if="success" class="p-4 my-4 bg-green-100 border">
              <span class="block pt-3 pr-12 text-2xl text-green-900">
                You have been unsubscribed from expired training notifications.
              </span>
            </div>

            <ErrorDisplay
              label="Unsubscribe Error"
              id="unsubscribe-training-error"
              :message="errorLabel"
              :message-is-html="true"
              :isVisible="(errorLabel?.length ?? 0) > 0"
            />
          </div>
        </div>
      </div>
    </BethsLayout>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, watch } from "vue";

import { useBldgStore } from "../store/bldgStore";
import { useTrainingStore } from "../store/trainingStore";
import { useRoute } from "vue-router";

const bldgStore = useBldgStore();
const trainingStore = useTrainingStore();
const route = useRoute();

const isPropertyLoading = computed(() => bldgStore.isLoading);
const property = computed(() => bldgStore.building);

const isWorking = ref(false);
const success = ref(false);
const errorLabel = ref<string | undefined>(undefined);
let hasRun = false;

const pid = Number.parseInt(route.query?.pid?.toString() ?? "", 10);
const token = route.query?.token?.toString() ?? "";

onMounted(unsubscribe);
watch(property, unsubscribe);

async function unsubscribe() {
  if (hasRun) return;

  if (!pid || Number.isNaN(pid) || !token) {
    errorLabel.value = "Invalid unsubscribe link.";
    return;
  }

  hasRun = true;
  isWorking.value = true;
  errorLabel.value = "";
  success.value = false;

  const result = await trainingStore.unsubscribeTraining(pid, token);

  if (!result) {
    success.value = true;
  } else {
    console.log("unsubscribeTraining result:", result);
    errorLabel.value = "Couldn't unsubscribe. Please try again later.";
  }
  isWorking.value = false;
}
</script>
